module.exports = __webpack_public_path__ + "img/CS48Q-中_03.75c19b93.jpg";